import * as React from 'react'

import { type NonFsdsTheme,resolveNonFsdsTheme } from '@/lib/non-fsds-theme'

interface NonFsdsFeatureSectionProps {
  features: string[]
  theme?: NonFsdsTheme | string
}

export default function NonFsdsFeatureSection({ features, theme = 'general' }: NonFsdsFeatureSectionProps) {
  const themeStyles = {
    general: { pillBg: 'bg-blue-50/80', pillBorder: 'hover:border-blue-200 hover:bg-blue-100/50 hover:shadow-blue-100/50', checkBg: 'bg-blue-600', textHover: 'group-hover:text-blue-900' },
    'english-academy': { pillBg: 'bg-blue-50/80', pillBorder: 'hover:border-emerald-200 hover:bg-emerald-100/50 hover:shadow-emerald-100/50', checkBg: 'bg-blue-600', textHover: 'group-hover:text-blue-900' },
    programming: { pillBg: 'bg-indigo-50/80', pillBorder: 'hover:border-indigo-200 hover:bg-indigo-100/50 hover:shadow-indigo-100/50', checkBg: 'bg-indigo-600', textHover: 'group-hover:text-indigo-900' },
    math: { pillBg: 'bg-teal-50/80', pillBorder: 'hover:border-teal-200 hover:bg-teal-100/50 hover:shadow-teal-100/50', checkBg: 'bg-teal-600', textHover: 'group-hover:text-teal-900' },
  }[resolveNonFsdsTheme(theme)]

  return (
    <section data-testid="non-fsds-feature-section" className="bg-white px-4 pt-16 sm:px-6 sm:pt-20 md:pt-24 pb-4">
      <div className="mx-auto max-w-7xl">
        <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-4 lg:gap-6">
          {features.map(item => (
            <div
              key={item}
              className={`group flex cursor-default select-none items-center gap-3 rounded-full border-2 border-transparent px-5 py-2.5 transition-all duration-300 hover:shadow-md sm:gap-4 sm:px-7 sm:py-3.5 ${themeStyles.pillBg} ${themeStyles.pillBorder}`}
            >
              <div className={`flex size-7 items-center justify-center rounded-full shadow-sm transition-transform duration-300 group-hover:scale-110 sm:size-8 ${themeStyles.checkBg}`}>
                <svg className="size-4 text-white sm:size-4.5" fill="none" viewBox="0 0 24 24" strokeWidth={3} stroke="currentColor" aria-hidden="true">
                  <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                </svg>
              </div>
              <span className={`text-sm font-bold text-slate-800 transition-colors duration-200 sm:text-base ${themeStyles.textHover}`}>{item}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
